<template>
  <el-empty description="No Data">
    <template #image>
      <img src="@/assets/images/notData.png" alt="notData" style="width: 80px;" />
    </template>
  </el-empty>
</template>